import React, { useState } from "react";
import GridBuilder from "UIBuilderEngine/GridBuilder";
import { useHistory } from "react-router-dom";
import { getContractJson } from "JsonFormat/ContractJson";
import Icon from "atoms/Icon";
import { Button, Form, Radio, Input, message } from "antd";
import styled from "styled-components";
import { CALL_API } from "common/API";
import { useTranslation } from "react-i18next";

const StyledDropzone = styled.div`
  font-size: 16px;
  .box {
    width: max-content;
    border-radius: 10px;
    padding: 15px;
    background-color: #f4f4f4;
  }
`;

const Contract = () => {
  const { t } = useTranslation();
  const [data, setData] = useState({});
  const { ContractForm } = getContractJson(data);
  const [viewDetails, setViewDetails] = useState(false);

  const history = useHistory();

  const onFinish = (values) => {
    //need for api
  };

  const handleFormChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmitForm = (e) => {
    setViewDetails(true);
  };
  const handleClickForm = (e) => {
    history.goBack();
  };

  const handleBackForm = (e) => {
    history.goBack();
  };

  return (
    <>
      {!viewDetails && (
        <>
          {t("Creating New Contract")}
          <>
            <GridBuilder
              formStructureJson={ContractForm}
              handleChange={handleFormChange}
              formSubmit={handleSubmitForm}
              initialValues={data}
              handleClick={handleClickForm}
              handleBack={handleBackForm}
            />
          </>
        </>
      )}
      {viewDetails && (
        <StyledDropzone>
          <div className="text-center">
            <h4>{t("AU Full time salaried employee")}</h4>
          </div>
          <a className="pb-2 ">3rd,Oct,2023</a>
          <br></br>
          <a className="">Henry</a>
          <br></br>
          <a className="">The Zenith, Tower B/821 Pacific HWY,Chatswood</a>
          <br></br>
          <a className=" pb-2">Sydney</a>
          <br></br>
          <p>
            {t("Dear")} <a className="">Henry</a>
          </p>
          <p>
            {t("Welcome to")} <a className="">Waila Technology</a>
          </p>
          <p>
            {t(
              "This contract sets out the terms and conditions for the employment"
            )}
          </p>
          <h4>1.{t("Employment")}</h4>
          <p>
            1.1 {t("The commencement date of your employment is")}{" "}
            <a className="">Date</a>
          </p>
          <div className="border-1">
            {t(
              "This commencement date will continue to be recognised for all purposes regarding your employment service, however this contract shall wholly replace any previous contract that applied to your employment from"
            )}{" "}
            <a className="">23rd Aug, 2023</a>
          </div>
          <p>
            1.2 {t("You are employed on a full time basis in the position of")}{" "}
            <a className="">Senior Sales Representative</a>.{" "}
            {t("You will report to")}{" "}
            <a className="">Will Smith, Managing Directer</a>{" "}
            {t(
              "or any other person directed by the Employer from time to time. The Employer may change your title, role, accountability or reporting relationship at any time where this change would be reasonable."
            )}
          </p>
          <div className="border-1">
            1.3 {t("You employment is subject to the")}{" "}
            <a className="">08th March, 2023</a>{" "}
            {t(
              "under which your classification is however the terms of this Instrument are not incorporated into this contract nor is there any intention to give them any contractual effect."
            )}
          </div>
          <br></br>
          <h4>2.{t("Location")}</h4>
          2.1 {t("Your usual place of employment will initially be")}{" "}
          <a className="text-center">Sydney </a>
          {t(
            "as well as any other location required to fulfil the duties of your position. You may at any time be required to work at a different location nominated by the Employer on either a temporary or permanent basis."
          )}
          <br></br>
          {t(
            "If you accept the terms contained in this contract, please sign the declaration below."
          )}
          <br></br>
          {t("Yours Sincerely")}
          <br></br>
          <div className="box mt-2">
            <Icon name="document"></Icon> {t("Upload Employer Signature")}
          </div>
          <br></br>
          <a className="">Tom Jackson</a>
          <br></br>
          <a className="">Managing Directer</a>
          <br></br>
          <a className="">Waila Technology</a>
          <br></br>
          <div className="box mt-2">
            <Icon name="document"></Icon>
            {t("Candidate Signature")}
          </div>
          <br></br>
          <a className="">Henry</a>
          <br></br>
          <hr></hr>
          <p>{t("How do you want to deliver this document?")}</p>
          <Form
            name="myForm"
            initialValues={{ remember: true }}
            onFinish={onFinish}
          >
            <Form.Item
              name="priority"
              rules={[
                { required: true, message: t("Please select priority!") },
              ]}
            >
              <Radio.Group>
                <Radio value="low">{t("Email")}</Radio>
                <Radio value="medium">{t("Hard Copy")}</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item name="message">
              <Input.TextArea rows={4} placeholder={t("Type...")} />
            </Form.Item>

            <Form.Item>
              <div className="text-end">
                <Button
                  type="secondry"
                  className="mx-2"
                  onClick={() => history.goBack()}
                >
                  {t("Cancel")}
                </Button>
                <Button
                  onClick={() => {
                    message.success(t("Created successfully"));
                    history.goBack();
                  }}
                  type="primary"
                  htmlType="submit"
                >
                  {t("Done")}
                </Button>
              </div>
            </Form.Item>
          </Form>
        </StyledDropzone>
      )}
    </>
  );
};
export default Contract;
